'use client';

import { SelectField } from '@petsmart-ui/sparky';
import type { ChangeEvent } from 'react';

import { NUMBER_OF_PETS_ITEMS } from '../model';

type NumberOfPetsFieldProps = {
    value: string;
    resetKey: number;
    errorMessage?: string;
    onValueChange: (value: string) => void;
    onFieldBlur: () => void;
};

export const NumberOfPetsField = ({
    value,
    resetKey,
    errorMessage,
    onValueChange,
    onFieldBlur,
}: NumberOfPetsFieldProps) => (
    <SelectField
        // Remount when the value changes so Sparky drops sparky-is-focused after the first
        // selection, without overriding focus styles that break the field chrome.
        key={`${resetKey}-${value}`}
        label="Number of pets"
        className="frequency-calculator-drawer__field frequency-calculator-drawer__pets-select"
        data-testid="frequency-calculator-number-of-pets"
        items={NUMBER_OF_PETS_ITEMS}
        value={value}
        isError={Boolean(errorMessage)}
        fieldNote={errorMessage}
        iconName={errorMessage ? 'exclamation-circle-fill' : undefined}
        onChange={(event: ChangeEvent<HTMLSelectElement>) => onValueChange(event.target.value)}
        onBlur={onFieldBlur}
    />
);
